<template>
  <div
    class="radio-button"
    :class="{
      'selected': selected,
      'correct': correct,
      'answered': answered,
      'large': size === 'large',
      'small': size === 'small',
      'extra-large': size === 'extra-large',
      'tiny': size === 'tiny',
      'is-sata': isSata,
    }"
  >
    <span
      v-if="useAnswerLabels"
      class="answer-label"
      :class="{
        'selected': selected,
        'correct': correct,
        'answered': answered,
      }"
    >
      {{ index2Letter }}
    </span>
    <icon
      v-else-if="iconName"
      :name="iconName"
      :variant="iconVariant"
      class="icon-size-8"
    ></icon>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';

export default {
  components: {
    Icon,
  },
  props: {
    answered: {
      type: Boolean,
      default: false,
    },
    correct: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    large: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '',
    },
    useAnswerLabels: {
      type: Boolean,
      default: false,
    },
    isSata: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    iconName() {
      if (!this.answered && !this.selected) return 'blank';
      if (this.answered && !this.selected && !this.correct) return 'blank';
      if (this.answered && this.selected && !this.correct) return 'cross-thin';

      return 'check-uui';
    },
    iconVariant() {
      if (this.iconName == 'cross-thin') return 'white';
      return '';
    },
    index2Letter() {
      return String.fromCharCode(65 + this.index);
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-button {
  display: inline-grid;
  place-items: center;
  width: rem-calc(18);
  height: rem-calc(18);
  box-sizing: border-box;
  border-radius: 50%;
  border: 1px solid #cdd5df;
  background-color: #eef2f6;
  cursor: pointer;

  &.is-sata {
    border-radius: 4px;
  }

  .answer-label {
    font-size: rem-calc(12);
    font-weight: 600;
    line-height: rem-calc(12);
    color: #697586;

    &.selected {
      color: white;
    }

    &.correct {
      color: white;
    }
  }

  &.selected {
    border: 1px solid #155EEF;
    background-color: #155EEF;

    &.answered:not(.correct) {
      border: 1px solid #F04438;
      background-color: #F04438;
    }
  }

  &.correct.answered {
    border: 1px solid #00b46d;
    background-color: #00b46d;
  }

  &.large {
    width: rem-calc(22);
    height: rem-calc(22);

    .icon-size-8 {
      width: rem-calc(10);
      height: rem-calc(10);
    }
  }

  &.extra-large {
    width: rem-calc(36);
    height: rem-calc(36);

    .icon-size-8 {
      width: rem-calc(18);
      height: rem-calc(18);
    }
  }

  &.small {
    width: rem-calc(16);
    height: rem-calc(16);
  }

  &.tiny {
    width: rem-calc(10);
    height: rem-calc(10);

    .icon-size-8 {
      width: rem-calc(5);
      height: rem-calc(5);
    }
  }

  .icon-size-8 {
    width: rem-calc(8);
    height: rem-calc(8);
  }
}
</style>
